const experience = [
    // {
    //     key: 1,
    //     job_title: "Associate Business Analyst",
    //     company: "Shell",
    //     duration: "Aug 2023 - Present",
    //     description: "I analyze processes, build goals, communicate findings and best practices while working around in collaboration with other teams to deliver organized, better valued and managed processes."
    // },
    
    {
        key: 1,
        job_title: "Associate Business Analyst",
        company: "Shell India Markets Pvt. Ltd.",
        duration: "August 2023 - Current",
        description: "Experienced as an IT Divestments Business Analyst Analyst leading a team of 20+ professionals across 5+ workstreams to deliver IT landscapes within scope of divestments. Skills utilized include Negotiation, Stakeholder Collaboration, Strategy Analysis, Project Management and Solution Evaluation."
    },
    {
        key: 2,
        job_title: "UI/UX Designer",
        company: "Planet E-Com Solutions",
        duration: "May 2022 - Jun 2023",
        description: "Performed UI Designing, Graphic and Visual Design and Functional Testing as a part of my role under the company. Responsibilities shouldered in this role also included Communication and Researching skills along with client relationship building."
    },
    {
        key: 3,
        job_title: "Design Team Lead",
        company: "Amity Artificial Intelligence Club",
        duration: "Aug 2021 - Jun 2022",
        description: "Focused on making AI & ML related designs for informational and event posters that represent Amity AI Club's events as well as managing the design team to curate the content to people in a legible, clean and engaging way."
    },
    {
        key: 4,
        job_title: "UI/UX Designer Intern",
        company: "Safehack",
        duration: "Jun 2020 - Aug 2020",
        description: "Assigned with designing Cyber Security web applications. Skills learnt include Presentation and Research along with documentation."
    }
];

export default experience;